import React, { Fragment, useState } from "react";
import LevelTd from "./LevelTd";

export default function QuotableTest({ quotable, disabled, renderCheckbox, renderPrice }) {
  return (
    <tr>
      <td className="center">{renderCheckbox(quotable)}</td>
      <LevelTd level={quotable.level} disabled={disabled}>
        {quotable.test_name}
      </LevelTd>
      <td className="center">{quotable.lod}</td>
      <td className="center nowrap">{quotable.technique_name}</td>
      <td className="center">{quotable.accreditation_name}</td>
      <td className="center">
        {quotable.top_unit_name != "ABSOLUTE" && quotable.top_unit_name}
        {quotable.bottom_unit_name != "ABSOLUTE" &&
          quotable.top_unit_name != "ABSOLUTE" &&
          "/"}
        {quotable.bottom_unit_name != "ABSOLUTE" && quotable.bottom_unit_name}
      </td>
      <td className="center">{quotable.can_add_to_sample && renderPrice(quotable)}</td>
    </tr>
  );
}
